module.exports = __webpack_public_path__ + "img/roulette-x100.b5003857.svg";